import tectoastr from '@/lib/tectoastr';

type Error = { response: { data?: { error?: string } } };

const errorHandler = (error: Error) => {
	tectoastr.error(
		error?.response?.data?.error || (document?.getElementById('alerts-generic')?.innerHTML as unknown as string)
	);
};

export { errorHandler, Error };
